import { useAtom } from "jotai";
import { toast } from "react-toastify";
import merchantApi from "../api/merchantApi";
import { loadingAtom, merchantAtom } from "../store";

interface Params {
  onError?: () => any;
  onSuccess?: () => any;
}

const useMerchant = () => {
  const [, setMerchant] = useAtom(merchantAtom);
  const [, setIsLoading] = useAtom(loadingAtom);

  const fetch = async ({ onError, onSuccess }: Params) => {
    setIsLoading(true);
    const result = await merchantApi.getMerchant();
    setIsLoading(false);
    if (!result.ok) {
      toast.error("Merchant not found");
      return onError?.();
    }
    setMerchant(result.data.merchant);
    onSuccess?.();
  };

  return { fetch };
};

export default useMerchant;
